import { useQuery } from "@tanstack/react-query";
import { QUADMGetDefectOrFailure2 } from "../../odata/appu4dm/QAppU4DM";
import { ncKeys } from "./nc-keys";
import { odataFetch } from "../../lib/odata-fetch";
import { UADMGetDefectOrFailureResponse } from "../../odata/appu4dm/AppU4DMModel";

export function useNCFailures(ncId?: string) {
  const { data, ...query } = useQuery({
    queryKey: ncKeys.getNCFailures(ncId!),
    queryFn: ({ meta }) => fetchNCFailures(ncId!, meta!.token!),
    enabled: ({ meta }) => !!meta?.token && !!ncId,
  });

  return {
    ncFailures: data?.value,
    ...query,
  };
}

async function fetchNCFailures(ncId: string, token: string) {
  const path = new QUADMGetDefectOrFailure2().buildUrl({
    function: {
      NonConformanceId: ncId,
    },
  });

  return odataFetch<UADMGetDefectOrFailureResponse>({ path, token });
}
